<template>
  <div v-if="!$vuetify.breakpoint.mobile">
    <ThermDesktop />
    <TanksDesktop />
  </div>
  <div v-else>
    <ThermMobile />
    <TankMobile />
  </div>
</template>

<script>
import TanksDesktop from "@/components/Tanks/Desktop/tanks_desktop_main";
import TankMobile from "@/components/Tanks/Mobile/tank_mobile_main";
import ThermMobile from "@/components/Tanks/Mobile/therm_mobile";
import ThermDesktop from "@/components/Tanks/Desktop/therm_desktop_main";
export default {
  components: {
    TanksDesktop,
    TankMobile,
    ThermMobile,
    ThermDesktop,
  },
};
</script>
